/* eslint semi:0 */
import { Provider, } from 'react-redux'
import React, { PropTypes, } from 'react'
import { componentMount, } from 'application/appActions'
import appStore, { dispatch, addReducer, } from 'application/appStore'


export class MountedComponent extends React.Component {

  componentDidMount(){
    const { container, options, } = this.props
    const {
      component: Component,
      name: componentName,
      stateKey,
      reducer,
      props,
      sagas,
    } = container
    const componentProps = { options, ...(props || {}), }
    const ComponentInstance = <Component { ...componentProps } />
    addReducer(stateKey, reducer)
    dispatch(componentMount(ComponentInstance, componentName, sagas))
    this.renderedView = <Provider store={ appStore }>{ ComponentInstance }</Provider>
    this.forceUpdate()
  }

  render(){
    return this.renderedView || false
  }

}

MountedComponent.propTypes = {
  dispatch: PropTypes.func,
  container: PropTypes.object,
}


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/application/mountedComponent.js